const BgBigSpikeStar = ({ className }: { className?: string }) => {
  return (
    <svg
      width="160"
      height="160"
      viewBox="0 0 160 160"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`${className} pointer-events-none`}
    >
      <path d="M81.7732 0H78.1807V160H81.7732V0Z" fill="#3A3D50" />
      <path
        d="M160 81.7917V78.1992L0 78.1992V81.7917L160 81.7917Z"
        fill="#3A3D50"
      />
      <path
        d="M24.6653 22.1755L22.125 24.7158L135.261 137.852L137.801 135.312L24.6653 22.1755Z"
        fill="#3A3D50"
      />
      <path
        d="M137.824 24.6838L135.284 22.1436L22.1482 135.28L24.6885 137.82L137.824 24.6838Z"
        fill="#3A3D50"
      />
      <path
        d="M79.977 94.2825C87.865 94.2825 94.2595 87.888 94.2595 79.9999C94.2595 72.1119 87.865 65.7173 79.977 65.7173C72.0889 65.7173 65.6943 72.1119 65.6943 79.9999C65.6943 87.888 72.0889 94.2825 79.977 94.2825Z"
        fill="#3A3D50"
      />
    </svg>
  );
};

export default BgBigSpikeStar;
